import { INVALID_SELECT_NOT_EMPTY } from "@/constants/invalids";
import { replaceStr } from "@/utils/string";
import { validator } from "@/utils/validator";

const LOGIN_PURPOSE_LABEL = "ログイン目的";
const OTHER_PURPOSE_LABEL = "その他の目的";

export type TProductLoginForm = {
  purposes: string[];
  otherText?: string | null;
};

export const productLoginSchema = validator.object().shape({
  purposes: validator
    .array()
    .of(validator.string().required())
    .min(1, replaceStr(INVALID_SELECT_NOT_EMPTY, { path: LOGIN_PURPOSE_LABEL }))
    .label(LOGIN_PURPOSE_LABEL)
    .required(),
  otherText: validator.string().emptyToNull().label(OTHER_PURPOSE_LABEL).notRequired(),
});
